// Registers the immersive Git client as a full-editor-area main view, gated on
// the git capability (desktop-only). Mirrors registerGitSidebarPanel, but for
// the MainViewRegistry instead of the sidebar registry. App.tsx additionally
// gates the call on the slate.git plugin being enabled, so disabling /
// uninstalling the plugin live-removes the activity-bar Git item and view.

import type { PlatformBridge } from '@slate/core';
import { GitBranch } from 'lucide-react';
import { MainViewRegistry } from '../../mainview/MainViewRegistry';
import { GitClient } from './GitClient';

/**
 * Register the Git client main view. Returns a noop disposer when the platform
 * has no git capability (web), so callers can register unconditionally.
 */
export function registerGitMainView(platform: PlatformBridge): () => void {
  if (!platform.capabilities.git) return () => {};
  return MainViewRegistry.register({
    id: 'git',
    title: 'Git',
    icon: GitBranch,
    order: 10,
    Component: () => <GitClient platform={platform} />,
  });
}
